export default "__VITE_ASSET__BBBbHYAB__"